export class NoInternetError extends Error {
  constructor(message: string = "") {
    super(message);
    this.name = "NoInternetError";
  }
}
